<template>
  <div>
    <Header
      :showRegistrationModal = "showRegistrationModal"
      :showLoginModal = "showLoginModal"
      :settings = "settings"
      @openRegModal ="openRegModal"
      @openLogModal ="openLogModal"
    >
    </Header>
    <div class="p-breadcrumb about-us-bg">
      <v-container pa-0>
        <h1>{{$t('about.about_us')}}</h1>
      </v-container>

    </div>
    <v-container class="container-xxl about-content" grid-list-xl>
      <v-layout>
        <v-flex>
          <h2 class="g-title about-sub-title">{{ $t('about_giver') }}</h2>
          <div class="main-text-block text-center">
            <p class="page-text mt-3">{{ $t('about_giver_text_giver_is_charity') }}</p>
            <p class="page-text mt-3">
              {{ $t('about.we_believe_that_people_need') }}
            </p>
            <p class="page-text mt-3">
              {{ $t('happiness_is_when_you_give_without') }}
            </p>
            <p class="page-text mt-3">
              {{ $t('about.god_gives_us') }}
            </p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg6>
          <div class="info-block">
            <img src="../assets/images/content/about-us/mission-img.svg" alt="Mission image">
          </div>
        </v-flex>
        <v-flex lg6 class="d-flex align-center justify-center">
          <div class="info-block">
            <h2 class="g-title about-sub-title">{{ $t('about.our_mission') }}</h2>
            <p class="text-content mt-1">{{ $t('about.mission_text') }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="column-revers">
        <v-flex lg6 class="d-flex align-center justify-center">
          <div class="info-block">
            <h2 class="g-title about-sub-title">{{ $t('about.our_vision') }}</h2>
            <p class="text-content mt-1">{{ $t('about.charity_is_the_best') }}</p>
          </div>
        </v-flex>
        <v-flex lg6>
          <div class="info-block">
            <img src="../assets/images/content/about-us/vision-img.svg" alt="Vision image">
          </div>
        </v-flex>
      </v-layout>
      <div class="our֊team">
        <h2 class="g-title about-sub-title">{{$t('about.our_team')}}</h2>
        <div class="our֊team-block">
          <div class="block-item">
            <img src="../assets/images/content/about-us/founder.svg" alt="">
            <div class="name">{{$t('about.armen')}}</div>
            <div class="position">{{$t('about.founder')}}</div>
          </div>
          <div class="block-item">
            <img src="../assets/images/content/about-us/po.png" alt="">
            <div class="name">{{$t('about.tatev')}}</div>
            <div class="position">{{$t('about.product_owner')}}</div>
          </div>
          <div class="block-item">
            <img src="../assets/images/content/about-us/dev_1.svg" alt="">
            <div class="name">{{$t('about.harutyun')}}</div>
            <div class="position">{{$t('about.dev')}}</div>
          </div>
          <div class="block-item">
            <img src="../assets/images/content/about-us/dev_2.svg" alt="">
            <div class="name">{{$t('about.serine')}}</div>
            <div class="position">{{$t('about.dev')}}</div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Header from '../components/global/Header.vue'
const getSettings = function (settings, lang) {
  let _settings = []
  if (settings) {
    settings.forEach(setting => {
      setting.SettingTranslations.forEach(st => {
        if (!setting.value) {
          setting.value = st.value
        }
        if (st.languageId === lang.id) {
          setting.value = st.value
        }
      })
      _settings.push(setting)
    })
  }
  return _settings
}
export default {
  name: 'About',
  components: {
    Header
  },
  data: () => ({
    settings: [],
    confirmedEmailText: '',
    confirmedEmailType: 'error',
    showRegistrationModal: false,
    showLoginModal: false
  }),
  methods: {
    languageChanged (lang) {
      this.settings = getSettings(this.settings, lang)
    },
    openRegModal () {
      this.showRegistrationModal = !this.showRegistrationModal
    },
    openLogModal () {
      this.showLoginModal = !this.showLoginModal
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/sass/desktop/aboutPage";
</style>



// WEBPACK FOOTER //
// src/views/AboutPage.vue